<template>
  <div class="search">
    <div class="inputs">
      <el-form class="queryConditions">
        <el-row v-for="row in items">
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="6" v-for="cfg in row" :style="'width:'+cfg.width">
            <component :is="ctxMap[cfg.ctx]" v-bind="cfg" :activeIndex=activeIndex @input="onInput"/>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="action">
      <qx-btn v-if="showCreate" @click="onClick('create')">新建(New)</qx-btn>
      <qx-btn v-if="showExport" @click="onClick('export')">导出(Export)</qx-btn>
    </div>
  </div>
</template>

<script>
import QxBtn from "@/components/common/qx-btn"
import InputText from "@/components/common/InputText"
import InputSelect from "@/components/common/InputSelect"
import InputRadio from "@/components/common/InputRadio"

const ctxMap = {
  inputText: InputText,
  inputSelect: InputSelect,
  inputRadio: InputRadio,
};
export default {
  name: "BaseSearch",
  components: {QxBtn, InputText, InputSelect, InputRadio},
  props: {
    configs: Array,
    actions: Array,
    activeIndex: String,
    showCreate: Boolean,
    showExport: Boolean
  },
  data: function () {
    return {
      ctxMap: ctxMap,
    }
  },
  mounted: function () {
    this.init();
  },
  computed: {
    items: function () {
      return this.configs || []
    }
  },
  methods: {
    init: function () {

    },
    onInput: function (val) {
      this.$emit('input', val);
    },
    onClick: function (action) {
      this.$emit('action', action);
    }
  }
}
</script>

<style scoped>
.search {
  border: solid 1px #e9e9e9;
  padding: 15px;
}

.action {
  text-align: right;
}
</style>
